export const APP_BAR_HEIGHT = "70px";
export const APP_BOTTOM_BAR_HEIGHT = "55px";
export const FOOTER_HEIGHT = "158px";
